import React, { useRef, useState } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Typography } from "@material-ui/core";

import { appActionTypes, appActions } from "@ip-store/actions";
import { Button, Dialog, Form } from "@ip-widgets";

function SupportDialog({
  appActions,
  data,
  loading,
  department,
  section,
  user,
  ...props
}) {
  const ref = useRef();
  const [sent, setSent] = useState(false);

  const initialValues = {
    data,
    department: department ? department.toUpperCase() : null,
    message: "",
    section: section ? section.toUpperCase() : null,
    type: "Question",
    url: window.location.href,
    user: {
      email: user.email,
      employee:
        (user.app_metadata && user.app_metadata.employee_number) || user.sub,
      name: user.name,
    },
  };

  const types = ["Feedback", "Question"];

  function handleSubmit(values, formik) {
    appActions.postSupport(values, {
      onError: (data) => {
        formik.setErrors(data.errors);
      },
      onSuccess: () => setSent(true),
    });
  }

  return (
    !!process.env.REACT_APP_SUPPORT_URL && (
      <Dialog
        ref={ref}
        title="Contact Support"
        {...props}
        onAfterClose={() => setSent(false)}
      >
        {sent ? (
          <React.Fragment>
            <Dialog.Content>
              <Typography>
                Your message has been received. We will get back to you as soon
                as possible.
              </Typography>
            </Dialog.Content>
            <Dialog.Actions>
              <Button onClick={() => ref.current.close()}>Close</Button>
            </Dialog.Actions>
          </React.Fragment>
        ) : (
          <Form
            initialValues={initialValues}
            loading={loading}
            onSubmit={handleSubmit}
          >
            <Dialog.Content>
              <Form.Grid>
                <Form.Field.Select items={types} name="type" required />
                <Form.Field.Textarea name="message" required />
              </Form.Grid>
            </Dialog.Content>
            <Dialog.Actions>
              <Button loading={loading} type="submit">
                Send
              </Button>
            </Dialog.Actions>
          </Form>
        )}
      </Dialog>
    )
  );
}

const mapStateToProps = (state) => ({
  loading: state.app.loading[appActionTypes.POST_SUPPORT],
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  appActions: bindActionCreators(appActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SupportDialog);
